var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',[_c('StationsMap',{attrs:{"stations":_vm.stationsData,"loader":_vm.loaderStatus}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }